import { RiArrowLeftLine, RiSparkling2Line } from "react-icons/ri";
import MemoryButton from "./MemoryButton";
import css from "./memory.module.scss";

const countLabel = (count, query) =>
  query
    ? `${count} ${count === 1 ? "match" : "matches"}`
    : `${count} ${count === 1 ? "fact" : "facts"}`;

export default function MemoryHeader({ onBack, count, query, loading }) {
  return (
    <header className={css.header}>
      <div className={css.headerTop}>
        <MemoryButton
          variant="quiet"
          size="icon"
          className={css.btnBack}
          aria-label="Back to chat"
          icon={<RiArrowLeftLine />}
          onClick={onBack}
        />
        <h2 className={css.title}>Memory</h2>
        <span className={css.eyebrow}>
          <RiSparkling2Line />
          {loading || (!count && !query) ? "Memory" : countLabel(count, query)}
        </span>
      </div>
      <p className={css.subtitle}>
        Facts I remember across conversations. You can correct or forget them
        anytime. Sensitive details are saved only when you ask.
      </p>
    </header>
  );
}
